<template>
  <div>
    <van-sticky>
      <van-tabs
        @click="onClickOnlyOne"
        color="#16bbbf"
        title-active-color="#16bbbf"
      >
        <van-tab name="全部" title="全部"> </van-tab>
        <van-tab
          v-for="item in TitleList"
          :key="item.id"
          :name="item.id"
          :title="item.name"
        >
        </van-tab>
      </van-tabs>
    </van-sticky>

    <van-list :loading="loading" :finished="finished" finished-text="没有更多了"  offset="20" :immediate-check="false"
    @load="onLoad">
    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass" v-for="item in list" :key="item.index">
        <div @click="gotoUrl('/activity/detail/' + item.Id)">
          <div class="Content">
            <div
              style="display: inline-block; width: 33%"
              class="ContentA"
              ref="getHeight"
            >
              <img
                v-if="item.Imgs"
                style="
                  border-radius: 5px;
                  height: 90px;
                  object-fit: cover;
                  display: block;
                "
                :src="item.Imgs.split(',')[0]"
                alt=""
              />
              <img
                v-else
                style="
                  border-radius: 5px;
                  height: 90px;
                  object-fit: cover;
                  display: block;
                "
                src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                alt=""
              />
            </div>
            <div style="display: inline-block; width: 63%" class="ContentB">
              <div class="centerTitle van-multi-ellipsis--l2">
                {{ item.Title }}
              </div>
              <!-- <span
                class="centertime van-multi-ellipsis--l2"
                style="margin: 5px 0px; font-size: 13px; color: #666666"
                >{{ item.Summary }}</span
              > -->
            </div>
            <span
              class="centertime"
              style="
                float: right;
                margin-right: 6px;
                margin-top: -18px;
                color: black;
                color: #999;
              "
              >{{ item.CreateTime | timeFilter }}</span
            >
          </div>
        </div>
      </div>
      <!-- 没有更多数据了 -->
      <!-- <div v-if="hidden" class="hidden">── 没有更多数据了 ──</div> -->
    </div>
  </van-list>
    <!-- 发布活动 -->
    <div
      class="backTop"
      @click="gotoUrl('/activity/addActivity')"
      v-if="isWorkMan == 1"
    >
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId, getIsWorkMan } from "@/utils/auth";
import { GetDynamicPage } from "@/api/RealInfo";
export default {
  data() {
    return {
      isWorkMan: "",
      tkId: 0, //tab栏
      activeName: "",
      list: [], //资讯列表
      listform: {
        page: 0,
        limit: 10,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [
        {
          id: 1,
          name: "街道",
        },
        {
          id: 2,
          name: "社区",
        },
      ],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    // 发布活动
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    // 上拉加载需要的函数
      onLoad() {
        console.log("asdsad");
        this.listform.page = this.listform.page+1 ;
        this.loading = true;
        this.getList();
      },

    // 获取分页列表
    getList() {
      GetDynamicPage(this.listform)
        .then((res) => {
          this.loading = false;
          console.log(res,1111);
          if (res.data.code == 0) {
            let rows = res.data.data; //请求返回当页的列表
            // 加载状态结束
            console.log(rows);
            if (rows == null || rows.length === 0) {
              // 加载结束
              console.log("结束");
              this.finished = true;
              return;
            }
            // 将新数据与老数据进行合并 concat合并数组
            this.list = this.list.concat(rows);
            console.log(this.list, 222);
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (this.list.length >= res.data.count) {
              this.finished = true;
            }
          }else{
            this.finished = true;
          }
        })

    },

    // tab点击切换事件
    onClickOnlyOne(name, title) {
      console.log(name);
      this.finished = false;
      if (name == "全部") {
        var names = null;
      } else {
        var names = name;
      }
      this.list = [];
      this.listform.Type = names;
      this.listform.page = 0;
      console.log(this.listform.Type);
      this.onLoad();

    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.isWorkMan = getIsWorkMan();
  },
  created(){
    this.onLoad()
  }
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}
</style>
